/* ==========================================================================
   dtc-cart.js — progressive enhancement for sections/main-cart.liquid

   The cart page is a fully functional native <form> without this file.
   Everything below is optional sugar:
     - +/- steppers and the quantity input patch the line through
       /cart/change.js instead of a full page POST
     - "Remove" does the same with quantity 0
     - the section re-renders itself via the Section Rendering API
     - header cart count + toast stay in sync

   On any failure we fall back to the browser's own behaviour (submit the
   form / follow the remove link), so the cart can never get stuck.
   ========================================================================== */
(function () {
  'use strict';

  var DTC = window.DTC;
  if (!DTC || !DTC.register) return;

  DTC.register('cart', {
    init: function (root) {
      var sectionId = root.getAttribute('data-section-id');
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      var changeUrl = root.getAttribute('data-change-url') || '/cart/change';
      var busy = false;

      function body() { return root.querySelector('[data-cart-body]'); }

      // The native "Update" submit is redundant once JS is running.
      function hideUpdate() {
        root.querySelectorAll('[data-cart-update]').forEach(function (b) { b.hidden = true; });
      }

      function setBusy(state) {
        busy = state;
        var el = body();
        if (el) el.classList.toggle('is-busy', state);
      }

      /* Re-render the whole section from the server. Keeps Liquid the single
         source of truth for money formatting, discounts and totals. */
      function rerender() {
        var url = cartUrl + (cartUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
        return fetch(url, { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('[data-cart-body]');
            var current = body();
            if (next && current) current.replaceWith(next);
            hideUpdate();
          });
      }

      function change(line, quantity, announce) {
        if (busy) return;
        setBusy(true);
        fetch(changeUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart change failed');
            return r.json();
          })
          .then(function (cart) {
            DTC.setCartCount(cart.item_count);
            return rerender().then(function () {
              if (announce) DTC.toast(announce);
            });
          })
          .catch(function () {
            // Give up on the nice path — let the server render it.
            window.location.href = cartUrl;
          })
          .then(function () { setBusy(false); });
      }

      function lineOf(el) {
        var item = el.closest('[data-cart-line]');
        return item ? parseInt(item.getAttribute('data-cart-line'), 10) : 0;
      }

      var offClick = DTC.on(root, 'click', function (e) {
        var remove = e.target.closest('[data-cart-remove]');
        if (remove) {
          e.preventDefault();
          change(lineOf(remove), 0, 'Removed from cart');
          return;
        }

        var step = e.target.closest('[data-qty-btn]');
        if (step) {
          e.preventDefault();
          var wrap = step.closest('[data-qty]');
          var input = wrap && wrap.querySelector('[data-qty-input]');
          if (!input) return;
          var next = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-btn'), 10);
          if (next < 0) next = 0;
          input.value = next;
          change(lineOf(step), next);
        }
      });

      var offChange = DTC.on(root, 'change', function (e) {
        var input = e.target.closest('[data-qty-input]');
        if (!input) return;
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) qty = 0;
        input.value = qty;
        change(lineOf(input), qty);
      });

      hideUpdate();

      return function cleanup() {
        offClick();
        offChange();
      };
    }
  });
}());
